import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Store } from '@ngrx/store';
import { selectAllStudentIds } from '../../store/students/student.selectors';
import { AccessChangeMonitorService } from '../auth/access/access-change-monitor.service';
import { AuthService } from '../auth/auth.service';
import { AnnouncementsService } from '../communication/announcements.service';

@Injectable({
  providedIn: 'root',
})
export class RefreshService {
  private readonly announcementsService = inject(AnnouncementsService);
  private readonly accessChangeMonitor = inject(AccessChangeMonitorService);
  private readonly store = inject(Store);
  protected authService = inject(AuthService);
  protected router = inject(Router);
  private readonly studentIds = toSignal(this.store.select(selectAllStudentIds), { initialValue: [] });

  refreshApp() {
    // Prevent refresh on public (unauthenticated) pages
    const publicRoutes = [
      '/login',
      '/activate',
      '/support',
      '/reset-password',
      '/username-recovery',
      '/unauthorised',
      '/privacy-policy',
      '/faqs',
    ];
    const currentUrl = this.router.url.split('?')[0];
    if (publicRoutes.includes(currentUrl)) {
      return;
    }
    setTimeout(() => {
      if (this.authService.isAuthenticated() === true) {
        this.refreshAnnouncements();
      }
      void this.refreshAccessChanges();
      this.refreshStatusBar();
    }, 500);
  }

  async refreshAccessChanges(): Promise<void> {
    await this.accessChangeMonitor.checkAndOpenAccessAlertIfNeeded();
  }

  refreshAnnouncements() {
    const studentIds = this.studentIds();
    if (studentIds.length > 0) {
      this.announcementsService.loadUnreadCount(studentIds);
      this.announcementsService.loadAnnouncements(studentIds);
      console.log('Announcements refreshed for students:', studentIds);
    } else {
      console.log('No students found to refresh announcements.');
    }
  }

  refreshStatusBar() {
    if (Capacitor.getPlatform() === 'android') {
      StatusBar.setStyle({ style: Style.Light });
      StatusBar.setBackgroundColor({ color: '#ffffff' });
    }
  }
}
